export const systemAppCode = {
  cubeApp: 'seewo-yunban-mobile',
  campusMiniprogram: 'seewo-campus-mobile-miniprogram-app',
};

// 发送短信模版的类型
export const templateSmsType = {
  yunban: 'Seewo.sms.yunban.UserLogOff',
  cube: 'Seewo.sms.SeewoCube.UserLogOff'
}

//应用类型
export const systemAppType = {
  app: 1,
  miniprogram: 2
}

//角色类型
export const roleType =  {
  teacher: 1,
  parents: 2,
  manager: 1
}

export const explanationData: {
  [key: string]: {
    title: string;
    content: string;
  }[];
} = {
  [systemAppCode.cubeApp]: [
    {
      title: '帐号与设备的管理关系解除',
      content: '如果您是设备管理员，请先进入「设备管理」解绑设备。',
    },
  ],
  campusMiniProgramTeacher: [
    {
      title: '没有待审核的请假和信发',
      content: '如果存在，请审核请假和信发内容。',
    },
    {
      title: '不是学校的高级管理员。',
      content: '如果是，请在希沃魔方云后台转让高级管理权限。',
    },
  ],
  campusMiniProgramParent: [],
};

export const riskListData = {
  [systemAppCode.cubeApp]: [
    {
      title: '永久注销，无法登录',
      content: '帐号一旦注销，无法再次登录使用，且无法恢复。',
    },
    {
      title: '所有数据将被删除，无法找回',
      content:
        '注销后您的名字、头像、孩子绑定关系、聊天记录、历史消息等信息将被清空，且无法恢复。',
    },
    {
      title: '设备特权服务将清空，无法恢复',
      content: '注销后，您订阅的音视频通话服务与电子学生证服务将无法使用。',
    },
  ],
  campusMiniProgramTeacher: [
    {
      title: '永久注销，无法登录',
      content: '帐号一旦注销，无法再次登录使用，且无法恢复。',
    },
    {
      title: '所有数据将被删除，无法找回',
      content:
        '注销后您的名字、头像、孩子绑定关系、聊天记录、历史消息等信息将被清空，且无法恢复。',
    },
    {
      title: '与所有绑定的学校、班级解绑',
      content: '',
    },
  ],
  campusMiniProgramParent: [
    {
      title: '永久注销，无法登录',
      content: '帐号一旦注销，无法再次登录使用，且无法恢复。',
    },
    {
      title: '所有数据将被删除，无法找回',
      content:
        '注销后您的名字、头像、孩子绑定关系、聊天记录、历史消息等信息将被清空，且无法恢复。',
    },
    {
      title: '设备特权服务将清空，无法恢复',
      content: '注销后，您订阅的音视频通话服务与电子学生证服务将无法使用。',
    },
  ]

};

//注销时对应后台的失败信息
export const conditionType = {
  basicInfo: '1',
  deviceMange: '2',
  // messageManage: '3',
  // admin: '4' //
};
export const conditionList = [
  {
    title: '帐号下绑定电子学生证。请先解绑电子学生证，再注销帐号。',
    eventCode: conditionType.deviceMange,
    desc: '帐号下绑定学生证',
  }
];
